import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { PortalSidebar } from "./PortalSidebar";
import { Outlet, useLocation } from "react-router-dom";

const routeTitles: Record<string, string> = {
  "/portal/dashboard": "Dashboard",
  "/portal/modules": "Meine Module",
  "/portal/invoices": "Rechnungen",
  "/portal/support": "Support",
  "/portal/settings": "Einstellungen",
};

export default function PortalLayout() {
  const location = useLocation();
  const title = routeTitles[location.pathname] || "Kundenportal";

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <PortalSidebar />

        <div className="flex-1 flex flex-col">
          <header className="h-14 flex items-center border-b border-border bg-background/80 backdrop-blur-sm px-4 gap-3">
            <SidebarTrigger className="ml-1" />
            <span className="text-sm font-medium text-muted-foreground">{title}</span>
          </header>

          <main className="flex-1 bg-secondary/20">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
